"use strict";

exports.__esModule = true;
exports.default = exports.StyledRow = void 0;

var _stitches = require("../theme/stitches.config");

const StyledRow = (0, _stitches.styled)('div', {
  display: 'flex',
  position: 'relative',
  boxSizing: 'border-box',
  variants: {
    fluid: {
      true: {
        width: '100%'
      }
    }
  },
  defaultVariants: {
    fluid: true
  }
});
exports.StyledRow = StyledRow;
var _default = StyledRow;
exports.default = _default;